<axis-modal
  class="size-xlarge"
  #modalStateReview
>
  <axis-modal-header>
    <h1>UM/UIM Disclosures</h1>
  </axis-modal-header>
  <axis-modal-content>
    <app-modal-uimui-disclosure-pdf></app-modal-uimui-disclosure-pdf>
    <form [formGroup]="uninsuredSelection">
      <axis-card>
        <axis-card-body>
          <h1 class="axis-h3">Confirmation</h1>
          <div
            class="axis-form-group has-axis-required"
            [ngClass]="{
              'has-axis-error':
                uninsuredSelection.get('undoConfirmStateDis')?.invalid &&
                uninsuredSelection.get('undoConfirmStateDis').touched &&
                uninsuredSelection.get('undoConfirmStateDis').dirty,
            }"
          >
            <axis-checkbox
              heading="I confirm I have read and reviewed the State Disclosures.<span
              aria-hidden='true'
              class='axis-required-indicator'
              >*</span>"
              class="kind-custom"
              aria-hidden="true"
              formControlName="undoConfirmStateDis"
              [required]="true"
            ></axis-checkbox> @if ( uninsuredSelection.get("undoConfirmStateDis")?.invalid &&
            uninsuredSelection.get("undoConfirmStateDis").touched && uninsuredSelection.get("undoConfirmStateDis").dirty
            ) { <div class="axis-error-block">Please select checkbox.</div> }
          </div>
        </axis-card-body>
      </axis-card>
    </form>
  </axis-modal-content>
  <axis-modal-footer>
    <div class="axis-btn-wrapper">
      <div class="axis-btn-wrapper-right">
        <button
          axis-button
          class="axis-btn kind-link"
          (click)="modalStateReview.close()"
        >
          <span class="axis-btn-icon-text">Close</span>
        </button>
        <button
          axis-button=""
          class="axis-btn kind-primary"
          type="button"
          (click)="onContinueClick()"
        >
          <span class="axis-btn-icon-text">Continue</span>
        </button>
      </div>
    </div>
  </axis-modal-footer>
</axis-modal>
